/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useState } from 'react';
import { Typography, notification, Form, Select, Col, Row, Input, Upload, Tooltip, Spin } from 'antd';
import ExcelJS from 'exceljs';
import * as XLSX from 'xlsx';
import { Button as CrceButton } from '@crc-evans/ui-components';
import {
  ArrowLeft,
  Check,
  Copy,
  Download,
  FileSpreadsheet,
  Loader2,
  Pencil,
  Trash2,
  Upload as UploadIcon,
  X,
  Plus,
} from 'lucide-react';
import './PQTTestPage.css';
import '../ShippingManagement/ShipmentDashBoardPage.css';
import { PqtMandatoryTestLabel, isPqtTestMandatory } from '../../utils/pqtTestLabel';

const { Text } = Typography;
import { connect } from 'react-redux';
import { get } from 'lodash';
import moment from 'moment';
import AddNewPQTStation from './AddNewPQTStation';
import {
  getProjectStationDetails,
  addProjectStationDetails,
  updateSowStationName,
  deleteSowStation,
} from '../../redux/PQTstation/action';
import AddNewPQTTest, { normalizePqtComparator } from './AddNewPQTTest';
import { fetchSowDetails } from '../../redux/PQTsowDetails/actions';
import { fetchTestTypes } from '../../redux/testDetails/action';
import {
  addTestDetails,
  deleteTestDetails,
  fetchStationTestDetails,
  updateTestDetails,
  fetchStationName,
  uploadITPAddstationFile,
} from '../../redux/PQTtestDetails/action';
import { AddTestDetails, OnUploadPQTTestFileData } from '../../redux/PQTtestDetails/saga';
import { AddStationDetails } from '../../redux/PQTstation/saga';
import CopyITPStationTest from './CopyITPStationTest';
const { Option } = Select;

const spinIndicator = <Loader2 className="pqt-inline-spin" size={20} aria-hidden />;
const criteriaListValue = [
  {
    id: 1,
    value: 'Accept/Reject/NA',
    valueType: 'ACCEPT_OR_REJECT_OR_NA',
    types: [
      {
        id: 1,
        value: 'Accept/Reject/NA',
        valueType: 'ACCEPT_OR_REJECT_OR_NA',
      },
    ],
  },
  {
    id: 2,
    value: 'Value',
    valueType: 'Value',
    types: [
      {
        id: 1,
        valueType: 'NONE',
        value: '',
      },
      {
        id: 2,
        valueType: 'DEGREE_CELSIUS',
        value: '°C',
      },
      {
        id: 3,
        valueType: 'MICRO_METER',
        value: 'μm',
      },
      {
        id: 4,
        valueType: 'MILLI_METER',
        value: 'mm',
      },
      // {
      //     id: 5,
      //     valueType: "ACCEPT_OR_REJECT_OR_NA",
      //     value: "Accept/Reject/NA"
      // },
      {
        id: 6,
        valueType: 'MICRO_SIEMENS',
        value: 'μS/cm',
      },
      {
        id: 7,
        valueType: 'MICROGRAM_CENTIMETERSQUARE',
        value: 'μg/cm²',
      },
      {
        id: 8,
        valueType: 'RATING',
        value: 'Rating',
      },
      {
        id: 9,
        valueType: 'NEWTON_PER_MM',
        value: 'N/mm',
      },
      {
        id: 10,
        valueType: 'JOULE_PER_MM',
        value: 'J/mm',
      },
      {
        id: 11,
        valueType: 'MEGAPASCAL',
        value: 'MPa',
      },
      {
        id: 12,
        valueType: 'PERCENTAGE',
        value: '%',
      },
      {
        id: 13,
        valueType: 'KILOVOLTS_PER_MM',
        value: 'KV/mm',
      },
      {
        id: 14,
        valueType: 'MILLIGRAMS_PER_SQUARE_METER',
        value: 'mg/m²',
      },
      {
        id: 15,
        valueType: 'MILLIGRAMS_PER_SQUARE_MM',
        value: 'N/mm²',
      },
      {
        id: 16,
        valueType: 'MINUTES',
        value: 'mins',
      },
      {
        id: 17,
        valueType: 'SECONDS',
        value: 'secs',
      },
      {
        id: 18,
        valueType: 'THOUSANDTHS_OF_INCH',
        value: 'mils',
      },
      {
        id: 19,
        valueType: 'MICRO_OUNCES_PER_SQUARE_INCH',
        value: 'μoz/in²',
      },
      {
        id: 20,
        valueType: 'MICRO_SIEMENS_PER_INCH',
        value: 'μS/in',
      },
      {
        id: 21,
        valueType: 'POUNDS_FORCE_PER_INCH',
        value: 'lbf/in',
      },
      {
        id: 22,
        valueType: 'SHORE_A',
        value: 'Shore A',
      },
      {
        id: 23,
        valueType: 'FAHRENHEIT',
        value: '°F',
      },
      {
        id: 24,
        valueType: 'BAR',
        value: 'Bar',
      },
      {
        id: 25,
        valueType: 'SHORE_D',
        value: 'Shore D',
      },
      {
        id: 26,
        valueType: 'PASSES',
        value: 'Passes',
      },
      {
        id: 27,
        valueType: 'PPM',
        value: 'ppm',
      },
    ],
  },
  {
    id: 4,
    value: 'Text',
    valueType: 'TEXT',
    types: [
      {
        id: 4,
        value: 'Text',
        valueType: 'TEXT',
      },
    ],
  },
];

const PQTTestPage = (props) => {
  const {
    selectedProject,
    showPQTTestPage,
    UpdatePage,
    setShowPQTTestPage,
    displayStr,

    onGetProjStationDetails,
    projStationDetails,
    isStationsLoading,
    onAddProjStationDetails,
    onAddTestDetails,
    onGetStationTestDetails,
    projStationTestData,
    onDeleteTestDetails,
    onFetchSowDetails,
    sowDetails,
    onUpdateStationName,
    onUpdateTestDetails,
    onDeleteSowStation,
    onFetchTestTypes,
    onUploadITPAddstation,
    isUploadAddstationLoading,
    onFetchStationName,
    projestStnNames,
    isStnNamesLoading,
    isSowLoading,
    sowList,
    stationList,
    testTypesList,
    setStationList,
    selectedSOW,
    sowITPDetails,
  } = props;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isStationModalVisible, setIsStationModalVisible] = useState(false);
  const [editValue, setEditValue] = useState(false);

  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [currentPagesize, setCurrentPagesize] = useState(10);
  const [listCount, setListCount] = useState(1);
  const [criteriaList, setCriteriaList] = useState(criteriaListValue);
  const [pipelines, setPipelines] = useState([]);

  const [activeKey, setActiveKey] = useState('1');

  const isWriteAccess = false;

  const [isTestModalVisible, setIsTestModalVisible] = useState(false);
  /** Only one station’s AddNewPQTTest should mount the modal — avoids stacked duplicates (“shadow”). */
  const [testModalSowStationId, setTestModalSowStationId] = useState(null);

  const setTestModalVisible = useCallback((visible) => {
    setIsTestModalVisible(visible);
    if (!visible) setTestModalSowStationId(null);
  }, []);
  const [itpData, setItpData] = useState([]);
  const [projStationTestList, SetProjStationTestList] = useState();
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [selectedTestData, setSelectedTestData] = useState('');
  const [ITPPipeline, setITPPipeline] = useState([]);
  const [PQtPipeline, setPQtPipeline] = useState([]);
  const [projectIdValue, setProjectIdValue] = useState(false);
  const [location, setLocation] = useState(['Mainline']);
  const [isEditStationName, setIsEditStationName] = useState(false);
  const [editId, setEditId] = useState(null);
  const [newStationName, setNewStationName] = useState('');
  const [loader, setLoader] = useState(false);

  const [loadingBtn, setLoadingBtn] = useState(false);
  const [isDeleteSowStation, setIsDeleteSowStation] = useState(false);
  const [deleteStationData, setDeleteStationData] = useState('');

  //for adding new station
  const [locationRef, setLocationRef] = useState();
  const [selectedLocation, setSelectedLocation] = useState(null);

  const [editStationForm] = Form.useForm();
  const [editStationCopyForm] = Form.useForm();
  const [selectStation] = Form.useForm();
  const [testForm] = Form.useForm();

  const [inputValue, setInputValue] = useState(true);
  const [valueObj, setValueObj] = useState('');
  const [testTypeValue, setTestTypeValue] = useState('');

  const [criteria, setCriteria] = useState('');
  const [testValue, setTestValue] = useState('');
  const [editTest, setEditTest] = useState(false);
  const [editTestId, setEditTestId] = useState(null);

  const [weldNameChange, setWeldNameChange] = useState(false);
  const [downloadEnabled, setDownloadEnabled] = useState(false);
  const [isWeldModalVisible, setIsWeldModalVisible] = useState(false);
  const [imagesRequired, setImagesRequired] = useState(false);
  const [stopwatchValueRequired, setStopwatchValueRequired] = useState(false);

  const [comparator, setComparator] = useState('<');

  const [weldForm] = Form.useForm();
  const [isCopyModalVisible, setIsCopyModalVisible] = useState(false);

  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [bulkUploadLoading, setBulkUploadloading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [disableFileUpload, setDisableFileUpload] = useState(false);

  const fileProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
      setDisableFileUpload(false);
    },
    beforeUpload: (file) => {
      setFileList([file]);
      setDisableFileUpload(true);
      return false;
    },
    fileList,
  };

  const handleTabChange = (key) => {
    setActiveKey(key);
  };

  const updatedCriteriaList = criteriaListValue.map((criteria) => {
    if ((displayStr && criteria.valueType === 'Value') || criteria.valueType === 'Table') {
      const types = displayStr.map((displayItem) => ({
        id: displayItem.id,
        value: displayItem.displayStr,
        valueType: displayItem.valueType,
      }));
      return {
        ...criteria,
        types: types,
      };
    } else {
      return criteria;
    }
  });

  useEffect(() => {
    const newCriteria = {
      id: 3,
      value: 'Table',
      valueType: 'TABLE',
      types: [
        {
          id: 1,
          valueType: 'NONE',
          value: '',
        },
        {
          id: 2,
          valueType: 'DEGREE_CELSIUS',
          value: '°C',
        },
        {
          id: 3,
          valueType: 'MICRO_METER',
          value: 'μm',
        },
        {
          id: 4,
          valueType: 'MILLI_METER',
          value: 'mm',
        },
        // {
        //     id: 5,
        //     valueType: "ACCEPT_OR_REJECT_OR_NA",
        //     value: "Accept/Reject/NA"
        // },
        {
          id: 6,
          valueType: 'MICRO_SIEMENS',
          value: 'μS/cm',
        },
        {
          id: 7,
          valueType: 'MICROGRAM_CENTIMETERSQUARE',
          value: 'μg/cm²',
        },
        {
          id: 8,
          valueType: 'RATING',
          value: 'Rating',
        },
        {
          id: 9,
          valueType: 'NEWTON_PER_MM',
          value: 'N/mm',
        },
        {
          id: 10,
          valueType: 'JOULE_PER_MM',
          value: 'J/mm',
        },
        {
          id: 11,
          valueType: 'MEGAPASCAL',
          value: 'MPa',
        },
        {
          id: 12,
          valueType: 'PERCENTAGE',
          value: '%',
        },
        {
          id: 13,
          valueType: 'KILOVOLTS_PER_MM',
          value: 'KV/mm',
        },
        {
          id: 14,
          valueType: 'MILLIGRAMS_PER_SQUARE_METER',
          value: 'mg/m²',
        },
        {
          id: 15,
          valueType: 'MILLIGRAMS_PER_SQUARE_MM',
          value: 'N/mm²',
        },
        {
          id: 16,
          valueType: 'MINUTES',
          value: 'mins',
        },
        {
          id: 17,
          valueType: 'SECONDS',
          value: 'secs',
        },
        {
          id: 18,
          valueType: 'THOUSANDTHS_OF_INCH',
          value: 'mils',
        },
        {
          id: 19,
          valueType: 'MICRO_OUNCES_PER_SQUARE_INCH',
          value: 'μoz/in²',
        },
        {
          id: 20,
          valueType: 'MICRO_SIEMENS_PER_INCH',
          value: 'μS/in',
        },
        {
          id: 21,
          valueType: 'POUNDS_FORCE_PER_INCH',
          value: 'lbf/in',
        },
        {
          id: 22,
          valueType: 'SHORE_A',
          value: 'Shore A',
        },
        {
          id: 23,
          valueType: 'FAHRENHEIT',
          value: '°F',
        },
        {
          id: 24,
          valueType: 'BAR',
          value: 'Bar',
        },
        {
          id: 25,
          valueType: 'SHORE_D',
          value: 'Shore D',
        },
        {
          id: 25,
          valueType: 'PASSES',
          value: 'Passes',
        },
        {
          id: 26,
          valueType: 'PPM',
          value: 'ppm',
        }
      ],
    };
    setCriteriaList([...updatedCriteriaList, newCriteria]);
  }, []);

  useEffect(() => {
    onFetchTestTypes();
  }, [selectedProject]);

  useEffect(() => {
    const ids = sowDetails.map((item) => item.id);
    const queryString = ids.map((id) => `sowId=${id}`).join('&');
    if (queryString) {
      // onFetchStationName(queryString)
    }
    setPQtPipeline(sowDetails);
    setDownloadEnabled(false);
  }, [sowDetails]);

  useEffect(() => {
    setITPPipeline(sowITPDetails);
  }, [sowITPDetails]);

  // /** Fetching API to get  Pipeline details  (SOW details)*/
  // useEffect(() => {
  //     const projId = get(selectedProject, 'id', undefined);
  //     sessionStorage.setItem('projectId', projId)
  //     if (projId) {
  //         setItpData([]);
  //         setLocation(null);
  //         setLocationRef(null);
  //         setLocationData([]);
  //         selectStation.resetFields();
  //         setIsEditStationName(false); setEditId(null); setNewStationName('')
  //        // onFetchSowDetails(projId);
  //         weldForm.resetFields();
  //         // setUpdateDisable(true)
  //         // setWeldNameChange(false)
  //         setSelectedLocation(null);
  //         setIsWeldModalVisible(false)
  //         setDownloadEnabled(true);
  //     }
  //     setProjectIdValue(projId);
  // }, [selectedProject]);

  // /** Getting Location details*/
  // useEffect(() => {
  //     setLocationData(sowDetails);
  // }, [sowDetails]);

  useEffect(() => {
    if (!Array.isArray(projStationDetails)) {
      //console.error("projStationDetails is not an array:", projStationDetails);
      return;
    }

    let itpObj = projStationDetails.map((station) => {
      let updatedStation = { ...station };

      if (station.PQTTests.length > 0) {
        updatedStation.projectStationId = station.PQTTests[0].projectStationId;

        if (testTypesList && testTypesList.length > 0) {
          updatedStation.PQTTests = station.PQTTests.map((test) => {
            let matchingTestType = testTypesList.find(
              (testType) => test.testValueTypeId === testType.id
            );
            return { ...test, valueType: matchingTestType?.valueType || null };
          });
        }
      } else {
        updatedStation.projectStationId = station.id;
      }

      return updatedStation;
    });

    setItpData(itpObj);
  }, [projStationDetails]);

  useEffect(() => {
    SetProjStationTestList(projStationTestData);
  }, [projStationTestData]);

  useEffect(() => {
    onGetProjStationDetails(selectedSOW.id);
    sessionStorage.setItem('sowId', selectedSOW.id);
  }, [selectedProject]);

  const fetchPQTStationTest = async () => {
    await onGetProjStationDetails(selectedSOW.id);
  };

  /**Function to Add stations */
  const onSave = async (station, customStationName) => {
    var obj = {
      statementOfWorkId: selectedSOW.id,
      stationId: station.id,
      name: station.name, //default value
      customStationName: customStationName,
    };

    await AddStationDetails(obj, station.name);
    await onGetProjStationDetails(selectedSOW.id);
    sessionStorage.setItem('sowId', selectedSOW.id);
    setIsStationModalVisible(false);
  };

  /** Function to add tests for stations */
  const onSaveTestDetails = async (data) => {
    var sowId = selectedSOW.id; //sessionStorage.getItem('sowId');
    //await onAddTestDetails({ data, sowId });
    await AddTestDetails(data, sowId);
    await onGetProjStationDetails(selectedSOW.id);
    //sessionStorage.setItem('sowId', selectedSOW.id);
  };

  /** Function to Update tests for stations */
  const onSaveEditTestDetails = async (data, testId) => {
    var sowId = selectedSOW.id; //sessionStorage.getItem('sowId');
    await onUpdateTestDetails({ data, testId, sowId });
    await onGetProjStationDetails(selectedSOW.id);
    //sessionStorage.setItem('sowId', selectedSOW.id);
  };

  const showDeleteModal = (record) => {
    setIsDeleteModalVisible(true);
    setSelectedTestData(record);
  };

  const showEditModal = (record, projectStationId) => {
    setTestModalSowStationId(projectStationId);
    setTestModalVisible(true);
    setEditTest(true);
    setEditTestId(record.id);
    setSelectedTestData(record);
    sessionStorage.setItem('sowStationId', projectStationId);
    let editData = null;
    let value = null;
    let valueUnit = null;

    if (record != null) {
      if (criteriaList.length > 0) {
        if (record.valueType === 'ACCEPT_OR_REJECT_OR_NA') {
          value = 'Accept/Reject/NA';
        } else if (record.typeOfTest === 'Text') {
          value = 'Text';
        } else if (record.typeOfTest === 'Table') {
          value = 'Table';
        } else value = 'Value';
        const selected = criteriaList.find((u) => u.value === value);


        //for Accept or Reject or NA
        if (selected && selected.id === 1) {
          setValueObj(selected.types);
          const testValueTypeId =
            testTypesList && testTypesList?.find((u) => u?.valueType === selected?.valueType);
          setTestTypeValue(testValueTypeId);
          setInputValue(false);
        } else if (selected && selected.id === 4) {
          setValueObj(selected.types);
          const testValueTypeId =
            testTypesList && testTypesList?.find((u) => u?.valueType === selected?.valueType);
          setTestTypeValue(testValueTypeId);
          setInputValue(false);
        } else if (selected && selected.id === 3) {
          setValueObj(selected.types);
          setInputValue(false);
          var valueUnitObj = selected.types;
          const selectedUnit = valueUnitObj?.find((u) => u?.valueType === record?.valueType);
          const testValueTypeId =
            testTypesList && testTypesList?.find((u) => u?.valueType === selectedUnit?.valueType);
          setTestTypeValue(testValueTypeId);
          setTestValue(selectedUnit?.value);
          valueUnit = selectedUnit?.value;
        }
        //for Value (°C, μm, mm, µS/cm)
        else {
          setValueObj(selected.types);
          setInputValue(true);
          var valueUnitObj = selected.types;
          const selectedUnit = valueUnitObj.find((u) => u.valueType === record.valueType);
          const testValueTypeId =
            testTypesList && testTypesList.find((u) => u.valueType === selectedUnit.valueType);
          setTestTypeValue(testValueTypeId);
          setTestValue(selectedUnit.value);
          valueUnit = selectedUnit.value;
        }
      }
      setCriteria(value);
      const comparatorNorm = normalizePqtComparator(record.comparator);
      editData = {
        testId: record.testId,
        typeOfTest: record.typeOfTest,
        criteria: value,
        testValue: valueUnit,
        minValue: record.minValue,
        comparator: comparatorNorm,
        maxValue: record.maxValue,
        mandatory: record.mandatory,
        imagesRequired: record.imagesRequired,
        stopwatchValueRequired: record.stopwatchValueRequired,
      };
      setImagesRequired(record.imagesRequired);
      setStopwatchValueRequired(record.stopwatchValueRequired);
      setComparator(comparatorNorm);
      testForm.setFieldsValue(editData);
    }
  };

  const handleOk = async () => {
    var sowId = selectedSOW.id; //sessionStorage.getItem('sowId');
    setLoadingBtn(true);
    onDeleteTestDetails({ testId: selectedTestData.id, sowId });
    // Saga refetches PQT stations on success; also refresh here after delete request settles
    setTimeout(() => {
      if (sowId) {
        onGetProjStationDetails(sowId);
      }
      setLoadingBtn(false);
      setIsDeleteModalVisible(false);
      setSelectedTestData('');
    }, 800);
  };

  const handleCancel = () => {
    setIsDeleteModalVisible(false);
    setSelectedTestData('');
  };

  // const selectedPipeline = (value) => {

  //     if (value) {

  //         // const locData = locationData.find(u => u.id === value);
  //         // setLocation(locData.pipelineSection);
  //         //for adding new station
  //         setLocationRef(locData.pipelineSection);
  //         // editStationForm.setFieldsValue({ locationRef: locData.pipelineSection });
  //         setSelectedLocation(locData);

  //         //get stations with respect to sow Id
  //         if (locData) {
  //             onGetProjStationDetails(selectedSOW.id);
  //             sessionStorage.setItem('sowId', selectedSOW.id);
  //         }
  //     } else {
  //         setItpData([]);
  //         setLocation(null);
  //         //for adding new station
  //         setLocationRef(null);
  //         editStationForm.resetFields();
  //         setSelectedLocation(null);
  //     }
  //     setIsEditStationName(false);
  // }

  const handleUpdateWeldName = (e, weld) => {
    if (weld === 'prefix') {
      setWeldPrefix(e.target.value);
    } else if (weld === 'suffix') {
      setWeldSuffix(e.target.value);
    }
    if (e.target.value) {
      setWeldNameChange(true);
    } else if (!weldPrefix || !weldSuffix) {
      setWeldNameChange(false);
    }
  };

  const getUnit = async () => {
    let unitFormulae = [];
    if (Array.isArray(criteriaList)) {
      criteriaList?.forEach((criteria) => {
        criteria?.types.forEach((type) => {
          if (type.value !== '') {
            unitFormulae.push(type.value);
          }
        });
      });
      unitFormulae = unitFormulae.slice(1);
      return unitFormulae;
    }
  };

  const getPipeline = async () => {
    let pipelineFormulae = [];
    if (Array.isArray(sowList)) {
      sowList?.forEach((item) => {
        if (item.pipelineSection !== '') {
          pipelineFormulae.push(item.pipelineSection);
        }
      });
      return pipelineFormulae;
    }
  };

  const getStation = async () => {
    let stationFormulae = [];
    if (Array.isArray(stationList)) {
      stationList?.forEach((item) => {
        if (item.name !== '') {
          stationFormulae.push(item.name);
        }
      });
      return stationFormulae;
    }
  };

  const getPipelineStation = async () => {
    let pipelineStationFormulae = [];
    if (Array.isArray(projestStnNames)) {
      projestStnNames?.forEach((item) => {
        if (item.name.trim() !== '') {
          pipelineStationFormulae.push(item.name);
        }
      });
      return pipelineStationFormulae;
    }
  };

  const addDropdownOptions = async (worksheet, columnLetter, options) => {
    let optionsSheet = worksheet.workbook.getWorksheet('Options');

    if (!optionsSheet) {
      optionsSheet = worksheet.workbook.addWorksheet('Options');
      optionsSheet.state = 'veryHidden';
    }

    options.forEach((value, index) => {
      optionsSheet.getCell(`${columnLetter}${index + 1}`).value = value;
    });

    for (let i = 2; i < 1000; i++) {
      worksheet.getCell(`${columnLetter}${i}`).dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: [`=Options!$${columnLetter}$1:$${columnLetter}$9999`],
      };
    }
  };

  const handleExportToExcel = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('PQT Data');

      // Define columns
      worksheet.columns = [
        { header: 'Test ID', key: 'testId', width: 15 },
        //{ header: 'Pipeline', key: 'pipeline', width: 18 },
        { header: 'Process Description', key: 'processDescription', width: 25 },
        { header: 'Applicable Standards & Code', key: 'applicableStandardsCode', width: 25 },
        { header: 'Test Equipment', key: 'testEquipment', width: 25 },
        { header: 'Acceptance Criteria', key: 'acceptanceCriteria', width: 25 },
        { header: 'Station Type', key: 'stationType', width: 18 },
        { header: 'Station Name', key: 'stationName', width: 18 },
        //  { header: 'Type Of Test', key: 'typeOfTest', width: 18 },
        { header: 'Criteria', key: 'criteria', width: 16 },
        { header: 'No. Of Sample', key: 'noOfSample', width: 16 },
        { header: 'Unit', key: 'testValue', width: 16 },
        { header: 'Min Value', key: 'minValue', width: 15 },
        { header: 'Comparator', key: 'comparator', width: 15 },
        { header: 'Max Value', key: 'maxValue', width: 15 },
        { header: 'Mandatory (True/False)', key: 'mandatory', width: 21 },
        { header: 'Images (True/False)', key: 'imagesRequired', width: 20 },
        { header: 'Stopwatch (True/False)', key: 'stopwatchValueRequired', width: 20 },
        { header: 'Table Row Names (separated by commas)', key: 'TableRowNames', width: 20 },
        { header: 'Table Column Names (separated by commas)', key: 'TableColumnNames', width: 20 },
        // { header: 'Table unit (separated by commas)', key: 'TableUnit', width: 20 },
        // { header: 'Table comparator (separated by commas)', key: 'TableComparator', width: 20 },
        // { header: 'Table min value (separated by commas)', key: 'TableMinValue', width: 20 },
        // { header: 'Table max value (separated by commas)', key: 'TableMaxValue', width: 20 },
      ];

      // Add header row styling
      const headerRow = worksheet.getRow(1);
      headerRow.height = 30;
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, size: 12 };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFE6E6FA' }
        };
      });

      // Add data from itpData
      let rowIndex = 0;
      itpData.forEach((station) => {
        if (station.PQTTests && station.PQTTests.length > 0) {
          station.PQTTests.forEach((test) => {
            // Handle table data
            let tableRowNames = '';
            let tableColumnNames = '';
            // let tableUnit = '';
            // let tableComparator = '';
            // let tableMinValue = '';
            // let tableMaxValue = '';
            if (test.tableData) {
              let parsedTableData = test.tableData;

              // If tableData is a JSON string, parse it
              if (typeof test.tableData === 'string') {
                try {
                  parsedTableData = JSON.parse(test.tableData);
                } catch (error) {
                  console.error('Error parsing tableData JSON:', error);
                  parsedTableData = null;
                }
              }

              if (parsedTableData && parsedTableData.rows && parsedTableData.columns) {
                tableRowNames = parsedTableData.rows.map(row => row.name).join(',');
                // tableUnit = parsedTableData.rows.map(row => row.unit).join(',');
                // tableComparator = parsedTableData.rows.map(row => row.comparator).join(',');
                // tableMinValue = parsedTableData.rows.map(row => row.minValue).join(',');
                // tableMaxValue = parsedTableData.rows.map(row => row.maxValue).join(',');
                // console.log("parsedTableData....", parsedTableData);
                // console.log("tableUnit....", tableUnit);
                tableColumnNames = parsedTableData.columns.join(',');
                // tableUnit = parsedTableData.unit.join(',');
                // tableComparator = parsedTableData.comparator.join(',');
                // tableMinValue = parsedTableData.minValue.join(',');
                // tableMaxValue = parsedTableData.maxValue.join(',');
              }
            }

            const row = worksheet.addRow({
              testId: test.testId,
              processDescription: test.processDescription || ' ',
              applicableStandardsCode: test.applicableStandardsCode || ' ',
              testEquipment: test.testEquipment || ' ',
              acceptanceCriteria: test.acceptanceCriteria || ' ',
              stationType: station.station.name,
              stationName: station.name,
              criteria: test.typeOfTest,
              noOfSample: test.noOfSample || ' ',
              testValue: getValueText(test.valueType),
              minValue: test.minValue,
              comparator: test.comparator,
              maxValue: test.maxValue,
              mandatory: test.mandatory ? 'True' : 'False',
              imagesRequired: test.imagesRequired ? 'True' : 'False',
              stopwatchValueRequired: test.stopwatchValueRequired ? 'True' : 'False',
              TableRowNames: tableRowNames,
              TableColumnNames: tableColumnNames,
            });

            // Add alternating row colors
            if (rowIndex % 2 === 1) {
              row.eachCell((cell) => {
                cell.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'FFF5F5F5' }
                };
              });
            }
            rowIndex++;
          });
        } else {
          // If no tests, still add station info
          const row = worksheet.addRow({
            testId: ' ',
            processDescription: ' ',
            applicableStandardsCode: ' ',
            testEquipment: ' ',
            acceptanceCriteria: ' ',
            stationType: station.station.name,
            stationName: station.name,
            criteria: ' ',
            noOfSample: ' ',
            testValue: ' ',
            minValue: ' ',
            comparator: ' ',
            maxValue: ' ',
            mandatory: ' ',
            imagesRequired: ' ',
            stopwatchValueRequired: ' ',
            TableRowNames: ' ',
            TableColumnNames: ' '
          });

          if (rowIndex % 2 === 1) {
            row.eachCell((cell) => {
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFF5F5F5' }
              };
            });
          }
          rowIndex++;
        }
      });

      // Auto-fit columns
      worksheet.columns.forEach(column => {
        column.width = Math.max(column.width, 15);
      });

      // Generate and download file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `PQT_Data_${new Date().toISOString().split('T')[0]}.xlsx`;
      link.click();

      // Clean up
      URL.revokeObjectURL(url);

      notification.success({
        message: 'Export Successful',
        description: 'PQT data has been exported to Excel successfully.',
      });
    } catch (error) {
      console.error('Export error:', error);
      notification.error({
        message: 'Export Failed',
        description: 'Failed to export data to Excel. Please try again.',
      });
    }
  };

  const handleDownloadTemplate = async () => {
    const unitFormulae = await getUnit();
    const pipelineFormulae = await getPipeline();
    const pipelineStationFormulae = await getPipelineStation();
    const stationFormulae = await getStation();
    const workbook = new ExcelJS.Workbook();
    const addStationSheet = workbook.addWorksheet('PQTStation');

    const headerRow = addStationSheet.getRow(1);
    headerRow.height = 40;

    addStationSheet.columns = [
      { header: 'Test ID', key: 'testId', width: 15 },
      //{ header: 'Pipeline', key: 'pipeline', width: 18 },
      { header: 'Process Description', key: 'processDescription', width: 25 },
      { header: 'Applicable Standards & Code', key: 'applicableStandardsCode', width: 25 },
      { header: 'Test Equipment', key: 'testEquipment', width: 25 },
      { header: 'Acceptance Criteria', key: 'acceptanceCriteria', width: 25 },
      { header: 'Station Type', key: 'stationType', width: 18 },
      { header: 'Station Name', key: 'stationName', width: 18 },
      //  { header: 'Type Of Test', key: 'typeOfTest', width: 18 },
      { header: 'Criteria', key: 'criteria', width: 16 },
      { header: 'No. Of Sample', key: 'noOfSample', width: 16 },
      { header: 'Unit', key: 'testValue', width: 16 },
      { header: 'Min Value', key: 'minValue', width: 15 },
      { header: 'Comparator', key: 'comparator', width: 15 },
      { header: 'Max Value', key: 'maxValue', width: 15 },
      { header: 'Mandatory (True/False)', key: 'mandatory', width: 21 },
      { header: 'Images (True/False)', key: 'imagesRequired', width: 20 },
      { header: 'Stopwatch (True/False)', key: 'stopwatchValueRequired', width: 20 },
      { header: 'Table Row Names (separated by commas)', key: 'TableRowNames', width: 20 },
      { header: 'Table Column Names (separated by commas)', key: 'TableColumnNames', width: 20 },
    ];

    //  await addDropdownOptions(addStationSheet, 'B', pipelineFormulae);
    await addDropdownOptions(addStationSheet, 'F', stationFormulae);
    await addDropdownOptions(addStationSheet, 'G', pipelineStationFormulae);
    await addDropdownOptions(addStationSheet, 'J', unitFormulae);

    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    for (let i = 2; i < 1000; i++) {
      const row = addStationSheet.getRow(i);

      if (i == 2) {
        const rowRows = row.getCell('TableRowNames');
        rowRows.value = 'Row 1,Row 2,Row 3';
        const rowColumn = row.getCell('TableColumnNames');
        rowColumn.value = 'Column 1,Column 2,Column 3';
      }
      const testIdColumn = row.getCell('testId');
      testIdColumn.dataValidation = {
        type: 'textLength',
        operator: 'lessThan',
        showErrorMessage: true,
        allowBlank: true,
        formulae: [6],
        errorStyle: 'error',
        error: 'Test ID length must be less than or equal to Five',
      };

      // const pipelineColumn = row.getCell('pipeline');
      // pipelineColumn.dataValidation = {
      //     type: 'list',
      //     allowBlank: true,
      //     formulae: [`=Options!$B$1:$B$9999`]
      //     // formulae: ['"' + location + '"']
      // };

      const stationTypeColumn = row.getCell('stationType');
      stationTypeColumn.dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: ['=Options!$F$1:$F$9999'],
      };

      // const stationNameColumn = row.getCell('stationName');
      // stationNameColumn.dataValidation = {
      //     type: 'list',
      //     allowBlank: true,
      //     formulae: ['=Options!$D$1:$D$9999']
      // };

      const criteriaColumn = row.getCell('criteria');
      criteriaColumn.dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: ['"Accept/Reject/NA,Value,Table,Text"'],
      };

      const unitColumn = row.getCell('testValue');
      unitColumn.dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: ['=Options!$J$1:$G$9999'],
      };

      const comparatorColumn = row.getCell('comparator');
      comparatorColumn.dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: ['"<, <=, >, >=, =, BETWEEN"'],
      };

      const mandatoryColumn = row.getCell('mandatory');
      mandatoryColumn.dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: ['"True,False"'],
      };

      const imagesRequiredColumn = row.getCell('imagesRequired');
      imagesRequiredColumn.dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: ['"True,False"'],
      };

      const stopwatchValueRequiredColumn = row.getCell('stopwatchValueRequired');
      stopwatchValueRequiredColumn.dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: ['"True,False"'],
      };
    }

    // Write to buffer
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'PQT Test Template.xlsx';
    link.click();
  };

  const showBulkUploadModal = () => {
    setBulkUploadModal(true);
    if (selectedProject) {
      setBulkUploadModal(true);
    } else {
      notification.warn({ message: 'Select Project to add data.' });
    }
  };

  const handleCancelUploadFile = () => {
    setFileList([]);
    setBulkUploadModal(false);
    setDisableFileUpload(false);
  };

  const handleUploadFile = async () => {
    if (fileList.length > 0) {
      const file = fileList[0];

      if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        const reader = new FileReader();

        reader.onload = async (event) => {
          try {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: 'array' });

            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];

            const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
            if (jsonData[1].length === 0) {
              throw new Error('Invalid file. Please select a valid file.');
            }

            const headers = jsonData[0];

            const keyMapping = {
              'Test ID': 'testId',
              //{ header: 'Pipeline', key: 'pipeline', width: 18 },
              'Applicable Standards & Code': 'applicableStandardsCode',
              'Process Description': 'processDescription',
              'Test Equipment': 'testEquipment',
              'Acceptance Criteria': 'acceptanceCriteria',
              'Station Type': 'stationType',
              'Station Name': 'stationName',
              'No. Of Sample': 'noOfSample',
              'Test ID': 'testId',
              Criteria: 'typeOfTest',
              Unit: 'testValue',
              'Min Value': 'minValue',
              Comparator: 'comparator',
              'Max Value': 'maxValue',
              'Mandatory (True/False)': 'mandatory',
              'Images (True/False)': 'imagesRequired',
              'Stopwatch (True/False)': 'stopwatchValueRequired',
            };

            //Validate swappedKeyMapping
            const allHeadersAvailable = Object.keys(keyMapping)
              .filter((key) => key !== 'ID') // Exclude 'ID' key
              .every((header) => headers.includes(header));

            // console.log('All Headers Available:', allHeadersAvailable);

            if (!allHeadersAvailable) {
              notification.error({ message: 'Invalid header file. Please select a valid file.' });
              return;
            }

            // console.log('point1......', formattedData);

            const formattedData = jsonData.slice(1).map((row) => {
              const tableData = { rows: [], columns: [] };
              const acc = {};

              headers.forEach((header, index) => {
                const value = row[index];

                if (header === 'No. Of Sample' && acc.typeOfTest != 'Value')
                  acc[keyMapping[header]] = null;
                else if (header === 'Table Column Names (separated by commas)' && value) {
                  tableData.columns = value.split(',').map((columnName) => columnName.trim());
                } else if (header === 'Table Row Names (separated by commas)' && value) {
                  tableData.rows = value.split(',').map((rowName) => ({
                    name: rowName.trim(),
                    values: [], // Temporarily empty, will update later
                  }));
                } else if (keyMapping[header]) {
                  acc[keyMapping[header]] = value !== undefined ? value : '';
                }
              });

              // Ensure `values` array in each row has the same length as `tableData.columns`
              tableData.rows.forEach((row) => {
                row.values = new Array(tableData.columns.length).fill(''); // Fill with empty strings
              });

              acc.tableData = acc.typeOfTest == 'Table' ? tableData : null; // Assign tableData to the object
              return acc;
            });

            // console.log('point2......', formattedData);

            //  console.log(formattedData);
            setBulkUploadloading(true);
            //Send the formatted data to your API
            var sowId = selectedSOW.id; //sessionStorage.getItem('sowId');
            await OnUploadPQTTestFileData(formattedData, sowId);
            await onGetProjStationDetails(selectedSOW.id);
            setBulkUploadloading(false);
            setBulkUploadModal(false);
          } catch (error) {
            console.log(error);
            notification.error({
              message: 'Oops! Unable to process the Excel file.',
              description: 'Please make sure you have selected a valid Excel file.',
            });
          }
        };

        reader.readAsArrayBuffer(file);
      } else {
        notification.warn({ message: 'Please select a valid Excel file (XLS or XLSX) to upload.' });
      }
    } else {
      notification.warn({ message: 'Please select a file to upload.' });
    }
  };

  const getValueText = (valueType) => {
    switch (valueType) {
      case 'NONE':
        return '';
      case 'DEGREE_CELSIUS':
        return '°C';
      case 'MICRO_METER':
        return 'μm';
      case 'MILLI_METER':
        return 'mm';
      case 'ACCEPT_OR_REJECT_OR_NA':
        return 'Accept/Reject/NA';
      case 'MICRO_SIEMENS':
        return 'µS/cm';
      case 'MICROGRAM_CENTIMETERSQUARE':
        return 'µg/cm²';
      case 'RATING':
        return 'Rating';
      case 'NEWTON_PER_MM':
        return 'N/mm';
      case 'JOULE_PER_MM':
        return 'J/mm';
      case 'MEGAPASCAL':
        return 'MPa';
      case 'PERCENTAGE':
        return '%';
      case 'KILOVOLTS_PER_MM':
        return 'KV/mm';
      case 'MILLIGRAMS_PER_SQUARE_METER':
        return 'mg/m²';
      case 'MILLIGRAMS_PER_SQUARE_MM':
        return 'N/mm²';
      case 'MINUTES':
        return 'mins';
      case 'SECONDS':
        return 'secs';
      case 'THOUSANDTHS_OF_INCH':
        return 'mils';
      case 'MICRO_OUNCES_PER_SQUARE_INCH':
        return 'μoz/in²';
      case 'MICRO_SIEMENS_PER_INCH':
        return 'μS/in';
      case 'POUNDS_FORCE_PER_INCH':
        return 'lbf/in';
      case 'SHORE_A':
        return 'Shore A';
      case 'FAHRENHEIT':
        return '°F';
      case 'BAR':
        return 'Bar';
      case 'SHORE_D':
        return 'Shore D';
      case 'PASSES':
        return 'Passes';
      case 'PPM':
        return 'ppm';
      default:
        return '';
    }
  };

  return (
    <div className="modern-pqt-test-page pqt-test-page-root d-flex flex-column">
      <div className="pqt-test-top flex-shrink-0">
        <div className="pqt-test-top-left">
          <CrceButton
            label="Back"
            variant="tertiary"
            size="small"
            icon={ArrowLeft}
            onClick={() => {
              UpdatePage(false);
            }}
          />
          <h1 className="pqt-test-pipeline-title">Pipeline: {selectedSOW.pipelineSection}</h1>
        </div>
        <div className="pqt-test-toolbar">
          <CrceButton
            label="Add station"
            variant="tertiary"
            size="small"
            icon={Plus}
            onClick={() => setIsStationModalVisible(true)}
          />
          <CrceButton
            label="Copy pipeline"
            variant="tertiary"
            size="small"
            icon={Copy}
            onClick={() => setIsCopyModalVisible(true)}
          />
          <CrceButton
            label="Bulk upload"
            variant="tertiary"
            size="small"
            icon={UploadIcon}
            onClick={() => showBulkUploadModal()}
          />
          <CrceButton
            label="Download template"
            variant="tertiary"
            size="small"
            icon={Download}
            onClick={() => handleDownloadTemplate()}
          />
          <CrceButton
            label="Export to Excel"
            variant="tertiary"
            size="small"
            icon={FileSpreadsheet}
            onClick={handleExportToExcel}
          />
        </div>
      </div>

      <div className="pqt-test-body flex-fill d-flex flex-column">
        <div className="pqt-test-scroll-area flex-fill overflow-auto">
          <Row gutter={16}>
                <Col lg={24} className="">
                  {itpData.length > 0 && isStationsLoading == false ? (
                    <div className="pqt-station-board">
                      {itpData &&
                        itpData.map((item, i) => {
                          return (
                            <div className="pqt-station-card" key={i}>
                              <div className="pqt-station-card-inner">
                                <div className="pqt-station-head station_name">
                                  {isEditStationName && i === editId ? (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                                      <Input
                                        className="edit_station_input pqt-station-edit-input"
                                        value={newStationName}
                                        onChange={(e) => setNewStationName(e.target.value)}
                                      />
                                      {!loader ? (
                                        <div className="pqt-station-inline-actions">
                                          <button
                                            type="button"
                                            className="pqt-test-action-btn"
                                            aria-label="Cancel rename"
                                            onClick={() => setIsEditStationName(false)}
                                          >
                                            <X size={18} strokeWidth={1.75} />
                                          </button>
                                          <button
                                            type="button"
                                            className="pqt-test-action-btn"
                                            aria-label="Apply rename"
                                            onClick={async () => {
                                              var sowId = selectedSOW.id; //sessionStorage.getItem('sowId');
                                              if (!newStationName.trim()) {
                                                notification.warning({
                                                  message: 'Please type a valid inputs to proceed!',
                                                });
                                                return;
                                              }
                                              setLoader(true);
                                              const data = {
                                                name: newStationName,
                                              };
                                              await onUpdateStationName({
                                                data,
                                                stationId: item.id,
                                                sowId: parseInt(sowId),
                                              });
                                              setTimeout(() => {
                                                setIsEditStationName(false);
                                                setLoader(false);
                                              }, 2000);
                                            }}
                                          >
                                            <Check size={18} strokeWidth={2} />
                                          </button>
                                        </div>
                                      ) : (
                                        <Spin indicator={spinIndicator} />
                                      )}
                                    </div>
                                  ) : (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', width: '100%' }}>
                                      <Tooltip title={item.name}>
                                        <Text className="m-0 pqt-station-name station_name_">{item.name}</Text>
                                      </Tooltip>
                                      <div className="pqt-station-inline-actions">
                                        <Tooltip title="Update station name">
                                          <button
                                            type="button"
                                            className="pqt-test-action-btn"
                                            aria-label="Rename station"
                                            disabled={isWriteAccess}
                                            onClick={() => {
                                              if (!isWriteAccess) {
                                                setIsEditStationName(true);
                                                setEditId(i);
                                                setNewStationName(item.name);
                                              }
                                            }}
                                          >
                                            <Pencil size={18} strokeWidth={2} />
                                          </button>
                                        </Tooltip>
                                        <Tooltip title="Delete station">
                                          <button
                                            type="button"
                                            className="pqt-test-action-btn pqt-test-action-btn--danger"
                                            aria-label="Delete station"
                                            disabled={isWriteAccess}
                                            onClick={() => {
                                              if (!isWriteAccess) {
                                                setIsDeleteSowStation(true);
                                                var sowId = selectedSOW.id; //sessionStorage.getItem('sowId')
                                                setDeleteStationData({
                                                  sowStationId: item.id,
                                                  sowId: parseInt(sowId),
                                                  name: item.name,
                                                });
                                              }
                                            }}
                                          >
                                            <Trash2 size={18} strokeWidth={2} />
                                          </button>
                                        </Tooltip>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="pqt-station-type-row">
                                  <Text className="m-0 pqt-station-type">
                                    <span className="pqt-station-type-label">Station type</span>
                                    <span className="pqt-station-type-value">{item.station.name}</span>
                                  </Text>
                                </div>
                                <div className="pqt-station-table-wrap">
                                  <Row className="pqt-test-table-head" gutter={[12, 8]}>
                                    <Col span={3}>
                                      <Text className="fw-medium">Test ID</Text>
                                    </Col>
                                    <Col span={5}>
                                      <Text className="fw-medium">Description</Text>
                                    </Col>
                                    <Col span={5}>
                                      <Text className="fw-medium">Criteria</Text>
                                    </Col>
                                    <Col span={3}>
                                      <Text className="fw-medium">Unit</Text>
                                    </Col>
                                    <Col span={4}>
                                      <Text className="fw-medium">Range</Text>
                                    </Col>
                                    <Col span={2}>
                                      <Text className="fw-medium"> </Text>
                                    </Col>
                                    <Col span={2}>
                                      <Text className="fw-medium"> </Text>
                                    </Col>
                                  </Row>
                                  <div className="pqt-test-rows-wrap test_height">
                                    {item.PQTTests &&
                                      item.PQTTests.length > 0 &&
                                      item.PQTTests.map((test, j) => {
                                        return (
                                          <Row
                                            justify="start"
                                            className="small pqt-test-row"
                                            key={test.id}
                                            gutter={[12, 8]}
                                          >
                                            <Col span={3} style={{ textAlign: 'left' }}>
                                              <Tooltip title={test.testId}>
                                                <Text className="pqt-test-cell pqt-test-cell--id test_text">
                                                  {test.testId}
                                                </Text>
                                              </Tooltip>
                                            </Col>
                                            <Col span={5} style={{ textAlign: 'left' }}>
                                              <Tooltip
                                                title={
                                                  isPqtTestMandatory(test.mandatory)
                                                    ? `${test.processDescription} (mandatory test)`
                                                    : test.processDescription
                                                }
                                              >
                                                <Text className="pqt-test-cell pqt-test-cell--desc test_text">
                                                  <PqtMandatoryTestLabel
                                                    label={test.processDescription}
                                                    mandatory={test.mandatory}
                                                  />
                                                </Text>
                                              </Tooltip>
                                            </Col>
                                            <Col span={5} className="text-center">
                                              {test.valueType === 'ACCEPT_OR_REJECT_OR_NA' ? (
                                                <Text className="pqt-test-cell">Accept/Reject/NA</Text>
                                              ) : (
                                                <Text className="pqt-test-cell">{test.typeOfTest}</Text>
                                              )}
                                            </Col>
                                            <Col span={3} className="text-center">
                                              {test.valueType === 'ACCEPT_OR_REJECT_OR_NA' || test.valueType === 'TEXT' ? (
                                                <Text className="pqt-test-cell-muted">-</Text>
                                              ) : (
                                                <Text className="pqt-test-cell">{getValueText(test.valueType)}</Text>
                                              )}
                                            </Col>
                                            <Col span={4} className="text-center">
                                              {test.valueType === 'ACCEPT_OR_REJECT_OR_NA' || test.valueType === 'TEXT' ? (
                                                <Text className="pqt-test-cell-muted">-</Text>
                                              ) : (
                                                <Text className="pqt-test-cell">
                                                  {`${test.comparator
                                                    ? test.comparator == 'BETWEEN'
                                                      ? ''
                                                      : test.comparator
                                                    : '-'
                                                  } ${test.minValue !== null && test.minValue !== '0.00' ? test.minValue : ''
                                                  }${test.comparator == 'BETWEEN' ? ' -' : ''} ${test.maxValue !== null && test.maxValue !== '0.00' ? test.maxValue : ''
                                                  }`}
                                                </Text>
                                              )}
                                            </Col>

                                            <Col span={2}>
                                              <div className="pqt-test-actions">
                                                <Tooltip title={`Update ${test.typeOfTest}`} placement="right">
                                                  <button
                                                    type="button"
                                                    className="pqt-test-action-btn"
                                                    aria-label={`Edit ${test.typeOfTest}`}
                                                    disabled={isWriteAccess}
                                                    onClick={() => {
                                                      if (!isWriteAccess) showEditModal(test, item.id);
                                                    }}
                                                  >
                                                    <Pencil size={18} strokeWidth={2} />
                                                  </button>
                                                </Tooltip>
                                                <Tooltip title={`Delete ${test.typeOfTest}`} placement="right">
                                                  <button
                                                    type="button"
                                                    className="pqt-test-action-btn pqt-test-action-btn--danger"
                                                    aria-label={`Delete ${test.typeOfTest}`}
                                                    disabled={isWriteAccess}
                                                    onClick={() => {
                                                      if (!isWriteAccess) showDeleteModal(test);
                                                    }}
                                                  >
                                                    <Trash2 size={18} strokeWidth={2} />
                                                  </button>
                                                </Tooltip>
                                              </div>
                                            </Col>
                                            <Col span={1} />
                                          </Row>
                                        );
                                      })}
                                  </div>
                                </div>
                                <div className="float-start add-test pqt-test-add-slot">
                                  <AddNewPQTTest
                                    isTestModalVisible={
                                      isTestModalVisible && testModalSowStationId === item.id
                                    }
                                    setIsTestModalVisible={setTestModalVisible}
                                    onPqtTestModalOpen={setTestModalSowStationId}
                                    sowStationId={item.id}
                                    testTypesList={testTypesList}
                                    onSaveTestDetails={onSaveTestDetails}
                                    onSaveEditTestDetails={onSaveEditTestDetails}
                                    testForm={testForm}
                                    criteriaList={criteriaList}
                                    inputValue={inputValue}
                                    setInputValue={setInputValue}
                                    valueObj={valueObj}
                                    setValueObj={setValueObj}
                                    testTypeValue={testTypeValue}
                                    setTestTypeValue={setTestTypeValue}
                                    criteria={criteria}
                                    setCriteria={setCriteria}
                                    testValue={testValue}
                                    setTestValue={setTestValue}
                                    setEditTest={setEditTest}
                                    editTest={editTest}
                                    editTestId={editTestId}
                                    loadingBtn={loadingBtn}
                                    setLoadingBtn={setLoadingBtn}
                                    imagesRequired={imagesRequired}
                                    setImagesRequired={setImagesRequired}
                                    stopwatchValueRequired={stopwatchValueRequired}
                                    setStopwatchValueRequired={setStopwatchValueRequired}
                                    comparator={comparator}
                                    setComparator={setComparator}
                                    selectedSOW={selectedSOW}
                                    selectedTestData={selectedTestData}
                                    //  projectTeamMembersAccessList={projectTeamMembersAccessList}
                                  />
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      {/* </Carousel> */}
                    </div>
                  ) : (
                    <div className="pqt-test-loading-shell">
                      <Spin size="large" spinning={!!isStationsLoading} />
                    </div>
                  )}
                </Col>
          </Row>
        </div>

        {isStationModalVisible && (
          <AddNewPQTStation
            className="details-modal"
            setIsModalVisible={setIsStationModalVisible}
            isModalVisible={isStationModalVisible}
            stationList={stationList}
            testTypesList={testTypesList}
            setStationList={setStationList}
            editValue={editValue}
            setEditValue={setEditValue}
            onSave={onSave}
            editStationForm={editStationForm}
            loadingBtn={loadingBtn}
            setLoadingBtn={setLoadingBtn}
          />
        )}

        {bulkUploadModal && (
          <div
            className="mc-dpr-modal-backdrop"
            role="presentation"
            onClick={() => !bulkUploadLoading && handleCancelUploadFile()}
          >
            <div
              className="mc-dpr-modal mc-dpr-modal--narrow"
              role="dialog"
              aria-labelledby="pqt-bulk-upload-title"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="mc-dpr-modal-head">
                <h3 id="pqt-bulk-upload-title" className="mc-dpr-modal-title">
                  Upload PQT station data
                </h3>
                <button
                  type="button"
                  className="mc-dpr-modal-close"
                  aria-label="Close"
                  disabled={bulkUploadLoading}
                  onClick={handleCancelUploadFile}
                >
                  <X size={20} />
                </button>
              </div>
              <div className="mc-dpr-modal-body">
                <p className="mc-dpr-modal-intro">
                  Select an Excel file (.xlsx) using the PQT test template format.
                </p>
                <div className="mc-dpr-modal-upload-wrap uploadFile_admin">
                  <Upload
                    {...fileProps}
                    maxCount={1}
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  >
                    <CrceButton
                      label="Select file"
                      variant="tertiary"
                      size="medium"
                      icon={UploadIcon}
                      disabled={disableFileUpload || bulkUploadLoading}
                    />
                  </Upload>
                </div>
              </div>
              <div className="mc-dpr-modal-foot">
                <CrceButton
                  label="Cancel"
                  variant="tertiary"
                  size="medium"
                  onClick={handleCancelUploadFile}
                  disabled={bulkUploadLoading}
                />
                <CrceButton
                  label={bulkUploadLoading ? 'Uploading…' : 'Upload'}
                  variant="primary"
                  size="medium"
                  onClick={() => handleUploadFile()}
                  disabled={bulkUploadLoading}
                />
              </div>
            </div>
          </div>
        )}

        {isDeleteModalVisible && (
          <div
            className="mc-dpr-modal-backdrop"
            role="presentation"
            onClick={() => !loadingBtn && handleCancel()}
          >
            <div
              className="mc-dpr-modal mc-dpr-modal--narrow mc-dpr-modal--delete"
              role="dialog"
              aria-labelledby="pqt-delete-test-title"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="mc-dpr-modal-head">
                <h3 id="pqt-delete-test-title" className="mc-dpr-modal-title">
                  Delete test details
                </h3>
                <button
                  type="button"
                  className="mc-dpr-modal-close"
                  aria-label="Close"
                  disabled={loadingBtn}
                  onClick={handleCancel}
                >
                  <X size={20} />
                </button>
              </div>
              <div className="mc-dpr-modal-body">
                <div className="mc-dpr-modal-delete-body">
                  <p className="mc-dpr-modal-delete-lead">
                    Deleting this test will delete all the associated welds.
                  </p>
                  <p className="mc-dpr-modal-delete-target">
                    {selectedTestData && selectedTestData.typeOfTest}
                  </p>
                  <p className="mc-dpr-modal-delete-warning">This action cannot be undone.</p>
                </div>
              </div>
              <div className="mc-dpr-modal-foot">
                <CrceButton
                  label="Cancel"
                  variant="tertiary"
                  size="medium"
                  onClick={handleCancel}
                  disabled={loadingBtn}
                />
                <CrceButton
                  label={loadingBtn ? 'Deleting…' : 'Delete'}
                  variant="primary"
                  size="medium"
                  onClick={handleOk}
                  disabled={loadingBtn}
                />
              </div>
            </div>
          </div>
        )}

        {isDeleteSowStation && (
          <div
            className="mc-dpr-modal-backdrop"
            role="presentation"
            onClick={() => {
              if (!loadingBtn) {
                setIsDeleteSowStation(false);
                setDeleteStationData('');
              }
            }}
          >
            <div
              className="mc-dpr-modal mc-dpr-modal--narrow mc-dpr-modal--delete"
              role="dialog"
              aria-labelledby="pqt-delete-station-title"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="mc-dpr-modal-head">
                <h3 id="pqt-delete-station-title" className="mc-dpr-modal-title">
                  Delete station
                </h3>
                <button
                  type="button"
                  className="mc-dpr-modal-close"
                  aria-label="Close"
                  disabled={loadingBtn}
                  onClick={() => {
                    setIsDeleteSowStation(false);
                    setDeleteStationData('');
                  }}
                >
                  <X size={20} />
                </button>
              </div>
              <div className="mc-dpr-modal-body">
                <div className="mc-dpr-modal-delete-body">
                  <p className="mc-dpr-modal-delete-lead">
                    Deleting this station will delete all associated data (tests and welds).
                  </p>
                  <p className="mc-dpr-modal-delete-target">{deleteStationData && deleteStationData.name}</p>
                  <p className="mc-dpr-modal-delete-warning">This action cannot be undone.</p>
                </div>
              </div>
              <div className="mc-dpr-modal-foot">
                <CrceButton
                  label="Cancel"
                  variant="tertiary"
                  size="medium"
                  onClick={() => {
                    setIsDeleteSowStation(false);
                    setDeleteStationData('');
                  }}
                  disabled={loadingBtn}
                />
                <CrceButton
                  label={loadingBtn ? 'Deleting…' : 'Delete'}
                  variant="primary"
                  size="medium"
                  onClick={async () => {
                    await onDeleteSowStation({
                      sowStationId: deleteStationData.sowStationId,
                      sowId: deleteStationData.sowId,
                      name: deleteStationData.name,
                    });

                    setLoadingBtn(true);
                    setTimeout(() => {
                      setLoadingBtn(false);
                      setIsDeleteSowStation(false);
                      setDeleteStationData('');
                    }, 1000);
                  }}
                  disabled={loadingBtn}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      {isCopyModalVisible && (
        <CopyITPStationTest
          className="details-modal"
          setIsCopyModalVisible={setIsCopyModalVisible}
          isCopyModalVisible={isCopyModalVisible}
          // editStationCopyForm={editStationCopyForm}
          ITPPipeline={ITPPipeline}
          setITPPipeline={setITPPipeline}
          PQtPipeline={PQtPipeline}
          setPQtPipeline={setPQtPipeline}
          selectedProject={selectedProject}
          isWriteAccess={isWriteAccess}
          fetchPQTStationTest={fetchPQTStationTest}
        />
      )}
    </div>
  );
};

const mapStateToProps = ({
  stationPQTReducer,
  testPQTReducer,
  testReducer,
  sowPQTReducer,
  sow,
}) => {
  const projStationDetails = get(stationPQTReducer, 'projStationData', []);
  const isStationsLoading = get(stationPQTReducer, 'isStationsLoading', []);
  const projStationTestData = get(testPQTReducer, 'projStationTestData', []);
  const sowDetails = get(sowPQTReducer, 'sowData', []);
  const isSowLoading = get(sowPQTReducer, 'isSowLoading', []);
  //const displayStr = get(testPQTReducer, 'testTypes', []);
  const displayStr = get(testReducer, 'testTypes', []);
  const projestStnNames = get(testPQTReducer, 'stationNames', []);
  const isStnNamesLoading = get(testPQTReducer, 'isStationNameLoading', []);

  const sowITPDetails = get(sow, 'sowData', []);
  return {
    projStationDetails,
    isStationsLoading,
    projStationTestData,
    sowDetails,
    displayStr,
    projestStnNames,
    isStnNamesLoading,
    isSowLoading,
    sowITPDetails,
  };
};

const mapDispatchToProps = {
  onGetProjStationDetails: getProjectStationDetails,
  onAddProjStationDetails: addProjectStationDetails,
  onAddTestDetails: addTestDetails,
  onGetStationTestDetails: fetchStationTestDetails,
  onDeleteTestDetails: deleteTestDetails,
  onFetchSowDetails: fetchSowDetails,
  onUpdateStationName: updateSowStationName,
  onUpdateTestDetails: updateTestDetails,
  onDeleteSowStation: deleteSowStation,
  onFetchTestTypes: fetchTestTypes,
  onFetchStationName: fetchStationName,
  onUploadITPAddstation: uploadITPAddstationFile,
};

export default connect(mapStateToProps, mapDispatchToProps)(PQTTestPage);
